<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<v-btn color="primary" @click="addClick(1)" class="mr-3">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addDepartment') }}
				</v-btn>
				<v-btn color="primary" @click="addClick(2)">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addBranch') }}
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-row class="pl-3 mb-2">
					<v-btn
						small
						:color="fastFilterCountry == 0 ? 'primary' : ''"
						@click="fastFilterCountry = 0"
						class="mr-2"
						>Svi</v-btn
					>
					<v-btn
						small
						:color="fastFilterCountry == 1 ? 'primary' : ''"
						@click="fastFilterCountry = 1"
						class="mr-2"
						>Hrvatska</v-btn
					>
					<v-btn
						small
						:color="fastFilterCountry == 3 ? 'primary' : ''"
						@click="fastFilterCountry = 3"
						class="mr-2"
						>BiH</v-btn
					>
					<v-btn
						small
						:color="fastFilterCountry == 99 ? 'primary' : ''"
						@click="fastFilterCountry = 99"
						class="mr-2"
						>Inozemstvo</v-btn
					>
				</v-row>
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<TheTable
									:additional-filters="branchesTable.additionalFilters"
									:default-sort="branchesTable.defaultSort"
									:excel="true"
									:fields="branchesTable.headers"
									:header-selection-key="'branches-headers'"
									:filter-save-key="'branches-filters'"
									:height="branchesTable.height"
									:total-records="branchesTable.total"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in branchesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
										:style="item.mandate_expired ? 'border-left: 5px solid #ff5252' : ''"
									>
										<td
											v-if="branchesTable.selectedHeaders.includes('branch_type_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.branch_type.name }}
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											{{ item.name }}
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('country_id')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.country != undefined">{{ item.country.name }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('county_id')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.county != undefined">{{ item.county.name }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('president_id')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.president_id != null"
												>{{ item.president.first_name }}&nbsp;{{
													item.president.last_name
												}}</span
											>
											<span v-if="item.head_id != null"
												>{{ item.head.first_name }}&nbsp;{{ item.head.last_name }}</span
											>
											<span v-if="item.president_id == null && item.head_id == null">-</span>
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('mobile_phone_number')"
											@click="editClick(item.id, false)"
										>
											{{ item.mobile_phone_number }}
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('email')"
											@click="editClick(item.id, false)"
										>
											{{ item.email }}
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('last_assembly_date')"
											@click="editClick(item.id, false)"
										>
											{{ item.last_assembly_date_display }}
										</td>
										<td
											v-if="branchesTable.selectedHeaders.includes('branch_status_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.branch_status.name }}
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Branches',
	components: { TheTable },
	data: function () {
		return {
			branchesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.type'),
						value: 'branch_type_id',
						type: 'dropdown|branch-types',
						allowFilter: true,
					},
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.country'),
						value: 'country_id',
						type: 'dropdown|countries',
						allowFilter: true,
					},
					{
						text: this.$t('fields.county'),
						value: 'county_id',
						type: 'dropdown|counties',
						allowFilter: true,
					},
					{
						text: this.$t('fields.presidentHead'),
						value: 'president_id',
						type: 'dropdown|branch-presidents',
						allowFilter: true,
					},
					{
						text: this.$t('fields.mobilePhoneNumber'),
						value: 'mobile_phone_number',
						type: 'string',
						allowFilter: true,
					},
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.lastAssemblyDate'),
						value: 'last_assembly_date',
						type: 'date',
						allowFilter: true,
					},
					{
						text: this.$t('fields.status'),
						value: 'branch_status_id',
						type: 'dropdown|branch-statuses',
						allowFilter: true,
					},
				],
				additionalFilters: [
					{
						text: this.$t('fields.lastAssemblyDate'),
						value: 'last_assembly_date',
						type: 'date_range',
						allowFilter: true,
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: false,
				},
			},
			fastFilterCountry: 0,
		};
	},
	watch: {
		fastFilterCountry: {
			handler: function () {
				this.reloadData(this.branchesTable.lastRequest);
			},
			deep: true,
		},
	},
	methods: {
		addClick(branchTypeId) {
			this.$myStore.commit('setBranchType', branchTypeId);
			this.$nextTick(() => {
				this.$router.push('/branches/0');
			});
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/branches/' + id);
			} else {
				let routeData = this.$router.resolve('/branches/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.branchesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.branchesTable.lastRequest = request;
			request.fastFilterCountry = this.fastFilterCountry;
			let vm = this;
			this.$APICall(
				'get',
				'branches',
				request,
				(data, success) => {
					if (success) {
						vm.branchesTable.items = data.items;
						vm.branchesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.branchesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'branches',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/branches', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveWindowResize() {
			this.branchesTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.branches'), href: '/#/branches', disabled: true },
		]);
		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
